import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaSearch, FaChevronRight, FaTrash } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";

import "./styles/ContactsPage.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions_contacts from "../redux/actions/contactsActions";
import * as actions_message from "../redux/actions/messageActions";
import UserAvatar from "./UserAvatar";
import * as actions_event from "../redux/actions/eventActions";
import MiniLoader from "./MiniLoader";

function getInitials(name, lastName) {
  const first = (name || "").charAt(0);
  const last = (lastName || "").charAt(0);
  return `${first}${last}`.toUpperCase();
}

class ContactItem extends React.Component {
  onDeleteClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onDelete(this.props.item);
  };

  render() {
    const { item, onClick, deleting } = this.props;
    const preview = item.Message?.Text || "";
    const timestamp = item.Message?.CreatedAt || "";

    return (
      <li className="contacts-page-item">
        <Link
          className="contacts-page-item__link"
          to={`/chat/${item.ConversationId}`}
          onClick={onClick}
        >
          <div className="contacts-page-item__avatar-wrap">
            <UserAvatar
              src={item.Avatar}
              alt=""
              verified={item.Verified}
              user={item}
              size="md"
              imgClassName="contacts-page-item__avatar"
              initials={getInitials(item.Name, item.LastN)}
            />
            {item.Socket && <span className="contacts-page-item__online" />}
          </div>

          <div className="contacts-page-item__body">
            <div className="contacts-page-item__top">
              <span className="contacts-page-item__name">
                {item.Name} {item.LastN}
              </span>
              {timestamp && (
                <span className="contacts-page-item__time">{timestamp}</span>
              )}
            </div>
            <div className="contacts-page-item__bottom">
              <span className="contacts-page-item__preview">{preview}</span>
              {item.MessageCount > 0 && (
                <span className="contacts-page-item__badge">
                  {item.MessageCount}
                </span>
              )}
            </div>
          </div>

          <FaChevronRight className="contacts-page-item__chevron" />
        </Link>
        <button
          type="button"
          className="contacts-page-item__delete"
          onClick={this.onDeleteClick}
          disabled={deleting}
          aria-label={I18n.t("contact_delete")}
          title={I18n.t("contact_delete")}
        >
          <FaTrash />
        </button>
      </li>
    );
  }
}

class ContactList extends React.Component {
  state = {
    text_search: "",
  };

  getFilteredList = () => {
    const { contactList } = this.props;
    const query = this.state.text_search.trim().toUpperCase();

    if (!query) {
      return contactList || [];
    }

    return (contactList || []).filter((item) => {
      const name = `${item.Name || ""} ${item.LastN || ""}`.toUpperCase();
      return name.indexOf(query) > -1;
    });
  };

  onChange = (event) => {
    this.setState({ text_search: event.target.value });
  };

  onClick = (item) => {
    this.props.SetContact(item);
    this.props.ClearBadgetContact(item);
    this.props.SetContactMessage(item);
    this.props.SetContactEvent(item);
  };

  onDeleteContact = (item) => {
    alertify
      .confirm(
        I18n.t("warning"),
        I18n.t("contact_delete_confirm"),
        async () => {
          try {
            const result = await this.props.DeleteContact(
              item.Id,
              this.props.user_id,
              this.props.token
            );

            if (!result?.success) {
              alertify.warning(I18n.t(result?.error || "try_later"));
              return;
            }

            if (
              this.props.selectedContact &&
              this.props.selectedContact.Id === item.Id
            ) {
              this.props.ClearContact();
              this.props.ClearContactMessage();
            }
          } catch (error) {
            console.log(error);
          }
        },
        () => {}
      )
      .set("labels", {
        ok: I18n.t("contact_delete"),
        cancel: I18n.t("profile_configuration_delete_cancel"),
      });
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadMoreContacts(
          this.props.pageCount,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { contactList } = this.props;
    const filteredList = this.getFilteredList();
    const hasContacts = contactList && contactList.length > 0;
    const isSearching = this.state.text_search.trim().length > 0;

    if (!hasContacts) {
      return (
        <div className="contacts-page__empty">
          <Translate value="contact_not_list" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="contacts-page__search">
          <FaSearch className="contacts-page__search-icon" aria-hidden="true" />
          <input
            type="text"
            placeholder={I18n.t("search")}
            onChange={this.onChange}
            className="contacts-page__search-input"
            value={this.state.text_search}
            aria-label={I18n.t("search")}
          />
        </div>

        {filteredList.length === 0 ? (
          <div className="contacts-page__empty">
            <Translate value="not_found" />
          </div>
        ) : (
          <ul className="contacts-page__list">
            {filteredList.map((item) => (
              <ContactItem
                item={item}
                key={item.Id}
                onClick={() => this.onClick(item)}
                onDelete={this.onDeleteContact}
                deleting={this.props.deletingId === item.Id}
              />
            ))}
          </ul>
        )}

        {this.props.pageSize > 7 &&
          (this.props.loadingMore ? (
            <div className="contacts-page__load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="contacts-page__load-more">
              <button
                type="button"
                className="contacts-page__load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    contactList: reducer.contacts.list,
    pageCount: reducer.contacts.page_count,
    pageSize: reducer.contacts.page_size,
    loadingMore: reducer.contacts.loadingMore,
    deletingId: reducer.contacts.deletingId,
    selectedContact: reducer.contacts.item,
    error: reducer.contacts.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  SetContact: (item) => dispatch(actions_contacts.setContact(item)),
  ClearContact: () => dispatch(actions_contacts.clearContact()),
  ClearBadgetContact: (item) =>
    dispatch(actions_contacts.clearBadgetContact({ item })),
  LoadMoreContacts: (page_count, user_id, token) =>
    dispatch(actions_contacts.loadListScroll({ page_count, user_id, token })),
  SetContactMessage: (item) =>
    dispatch(actions_message.setContactMessage(item)),
  ClearContactMessage: () =>
    dispatch(actions_message.clearContactMessage()),
  SetContactEvent: (item) => dispatch(actions_event.setContactEvent(item)),
  DeleteContact: (contact_id, user_id, token) =>
    dispatch(actions_contacts.deleteContact({ contact_id, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactList);
